'use client'

import StepToGlbConverter from '@/components/StepToGlb/StepToGlbConverter'

export default function Page() {
  return <StepToGlbConverter />
}
